import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { useResponsive } from "../../hooks/useResponsive";
import { useDispatch, useSelector } from "react-redux";
import { toggleMobileOpenVariable } from "../../redux/menuBar/action";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function MenuAppBar({ myRef, title = "" }) {
  const [auth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const lgUp = useResponsive("up", "lg");
  const { mobileOpen, isClosing } = useSelector(
    (state) => state.menuBarReducer,
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleProfile = (event) => {
    setAnchorEl(event.currentTarget);
    navigate("/profileView");
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      dispatch(toggleMobileOpenVariable(!mobileOpen));
    }
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        background: "#1D5AB9",
        position: "sticky",
        top: 0,
        zIndex: "5",
      }}
    >
      <AppBar
        position="sticky"
        sx={{
          background: "#1D5AB9",
        }}
      >
        <Toolbar>
          {!lgUp ? (
            <IconButton
              size="large"
              edge="start"
              color={lgUp ? "white" : "#1D5AB9"}
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={handleDrawerToggle}
            >
              <MenuIcon style={{ color: !lgUp ? "white" : "#1D5AB9" }} />
            </IconButton>
          ) : (
            <></>
          )}
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontFamily: "Segoe UI",
              fontSize: 20,
              fontWeight: 600,
              margin: "auto",
              color: lgUp ? "white" : "white",
              textIndent: !lgUp ? "-25%" : "-15%",
              flexGrow: 1,
              textAlign: "center",
            }}
          >
            {title}
          </Typography>
          {auth && (
            <div style={{ position: "absolute", right: 0, end: 0 }}>
              <Tooltip title="Profile" arrow>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleProfile}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton>
              </Tooltip>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleClose}>
                  {t("pages.menuAppBar.text01")}
                </MenuItem>
                <MenuItem onClick={handleClose}>
                  {t("pages.menuAppBar.text02")}
                </MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
